<div class="user-list-detail-availability-percentage">
  <div
    class="percentage-number"
    data-cy="availability-match-percentage">
    {{ availabilityPercentage$ | async }}%
  </div>
  <div
    class="percentage-bar"
    [style.--gradient]="gradient$ | async"></div>
</div>
